import baseHttpService from "core/http/singleton/base";
import {
  getCandidateInProgramUrl,
  getDetailInterviewUrl,
  getEventsUrl,
  getListProgramURL,
  updateResultUrl,
  updateStatusParticipateUrl,
} from "./urls";

import { GetCandidateInProgramParam } from "./paramTypes";
export const getListEventApi = async (formFilter) => {
  const { screenCode, ...payload } = formFilter;

  const res = await baseHttpService.get(getEventsUrl(screenCode), payload);
  if (!res || !res.data) throw new Error("Opps");
  return res?.data;
};

export const getCandidateInProgramApi = async (
  // dùng chung api detail schedule và candidate in program
  params: GetCandidateInProgramParam
) => {
  const { screenCode, ...payload } = params;

  const res = await baseHttpService.get(
    getCandidateInProgramUrl(screenCode),
    payload
  );
  if (!res || !res.data) throw new Error("Opps");
  return res?.data;
};

export const getDetailInterviewApi = async (formFilter) => {
  const { screenCode, scheduleId, ...payload } = formFilter;

  const res = await baseHttpService.get(
    getDetailInterviewUrl({ screenCode, scheduleId }),
    payload
  );
  if (!res || !res.data) throw new Error("Opps");
  return res?.data;
};

export const updateStatusParticipateApi = async (formData) => {
  const { screenCode, itemCode, ...payload } = formData;

  const res = await baseHttpService.put(
    updateStatusParticipateUrl({ screenCode, itemCode }),
    payload
  );
  if (!res || !res.data) throw new Error("Opps");
  return res?.data;
};

export const updateResultApi = async (formData) => {
  const { screenCode, itemCode, ...payload } = formData;

  const res = await baseHttpService.put(
    updateResultUrl({ screenCode, itemCode }),
    payload
  );
  if (!res || !res.data) throw new Error("Opps");
  return res?.data;
};

export const getListProgramApi = async () => {
  const res = await baseHttpService.get(getListProgramURL);
  if (!res || !res.data) throw new Error("Opps");
  return res?.data;
};
